import * as React from 'react';
import { SvgIcon } from '@mui/material';
function wrapWithSvgIcon(component, props) {
    return React.createElement(SvgIcon, Object.assign({}, props), component);
}
function SvgBack(props) {
    return wrapWithSvgIcon(React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor" }, props),
        React.createElement("path", { d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" })), props);
}
export default SvgBack;
//# sourceMappingURL=Back.js.map